import { render, staticRenderFns } from "./index.vue?vue&type=template&id=33bf9e64&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=33bf9e64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bf9e64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33bf9e64')) {
      api.createRecord('33bf9e64', component.options)
    } else {
      api.reload('33bf9e64', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=33bf9e64&scoped=true&", function () {
      api.rerender('33bf9e64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/homeCard/buyer/purchaseOrder/index.vue"
export default component.exports